<!-- Specific day of the Week -->
<div class="one-column-container">
  <!-- Interval — icon prefix instead of matTextPrefix "Every" / matTextSuffix
       "day(s)". Material 19 draws vertical divider lines between text-prefix
       and input which read as visual noise; matIconPrefix has no divider.
       The unit ("days") moves into the mat-hint below the input. -->
  <mat-form-field appearance="outline">
    <mat-label>Interval</mat-label>
    <mat-icon matIconPrefix>replay</mat-icon>
    <input matInput type="number" [formControl]="interval" placeholder="1" min="1" />
    <mat-hint>Every {{ interval.value || 1 }} {{ getIntervalSuffix() }} between fires.</mat-hint>
    <mat-error *ngIf="intervalHasError()">{{intervalErrorMessage()}}</mat-error>
  </mat-form-field>

  <!-- Execution time — clock-face picker (ngx-mat-timepicker). Icon moved
       to matIconPrefix for visual consistency with Interval above and to
       avoid the suffix-divider line Material 19 draws. -->
  <mat-form-field appearance="outline" (click)="executionPicker.open()">
    <mat-label>Execution time</mat-label>
    <mat-icon matIconPrefix>schedule</mat-icon>
    <input matInput
           [formControl]="executionTime"
           [ngxMatTimepicker]="executionPicker"
           placeholder="Pick a time" />
    <ngx-mat-timepicker #executionPicker [enableKeyboardInput]="true"></ngx-mat-timepicker>
    <mat-hint align="start">Interpreted in the schedule's timezone. Blank = legacy midnight fallback.</mat-hint>
    <mat-hint align="end" *ngIf="executionTime.value">
      <a class="date-clear-link"
         (click)="$event.stopPropagation(); executionTime.setValue('')">Clear</a>
    </mat-hint>
  </mat-form-field>

  <mat-slide-toggle [formControl]="dependency" color="primary">
    Wait for previous execution to complete?
  </mat-slide-toggle>

  <mat-card-subtitle>Weekdays</mat-card-subtitle>
  <mat-chip-listbox [multiple]="true" [formControl]="selectedWeekdays">
    <mat-chip-option *ngFor="let day of weekdays" [value]="day">
      {{day | slice:0:3 | titlecase}}
    </mat-chip-option>
  </mat-chip-listbox>

  <!-- Continuation mode — replaced the dropdown with a button-toggle group so
       the two options are visible without a click. Same shape that bookwise /
       goldfish use for binary-ish enums. -->
  <div class="continuation-mode-row">
    <span class="field-label">
      Continuation Mode
      <mat-icon class="field-help-icon"
                matTooltip="STRICT: fire on the calendar; suspended events stay within today's time-ranges. CONTINUOUS: re-anchor to the previous execution's start; suspended events carry into the next day until done.">help_outline</mat-icon>
    </span>
    <mat-button-toggle-group [formControl]="continuationMode" hideSingleSelectionIndicator>
      <mat-button-toggle *ngFor="let mode of continuationModes" [value]="mode">
        <mat-icon class="toggle-icon">{{ mode === 'STRICT' ? 'event_available' : 'autorenew' }}</mat-icon>
        {{ mode | titlecase }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

</div>
